// js
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import SecurityOverviewSlices from './SecurityOverviewSlices';
import { securityColors, generateSecurityAnalysisLegendSubtext } from '../../utils/securityAnalysis';
import ColorLegend from '../common/ColorLegend';
// css
import '../../styles/components/analytics/SecurityOverview.scss';


class SecurityOverview extends Component {

  render() {
    const { aggregateData, criticalCorrelationCount, baseNavRoute } = this.props;
    const acceptableCriticalCorrelationCount = aggregateData.critical.acceptable;

    return (
      <div className='analytics__security-overview' id='pptx_security_overview'>
        <h2>
          <span>Security Recommendation: Overview</span>
          <Link to={`${baseNavRoute}/correlations/1`}>Edit correlations</Link>
        </h2>
        <div className='box'>
          <p>{acceptableCriticalCorrelationCount} of {criticalCorrelationCount} critical correlations are adequately supplied with indexed data.</p>
          <SecurityOverviewSlices data={aggregateData} />
          <ColorLegend
            items={[
              {
                colors: [
                  securityColors.acceptable
                ],
                label: 'Acceptable Indexed Data',
                subtext: generateSecurityAnalysisLegendSubtext('acceptable')
              },
              {
                colors: [
                  securityColors.rudimentary
                ],
                label: 'Rudimentary Indexed Data',
                subtext: generateSecurityAnalysisLegendSubtext('rudimentary')
              },
              {
                colors: [
                  securityColors.inadequate
                ],
                label: 'Inadequate Indexed Data',
                subtext: generateSecurityAnalysisLegendSubtext('inadequate')
              }
            ]}
          />
        </div>
      </div>
    );
  }
}

SecurityOverview.propTypes = {
  baseNavRoute: PropTypes.string.isRequired,
  aggregateData: PropTypes.object.isRequired,
  criticalCorrelationCount: PropTypes.number.isRequired
};

export default SecurityOverview;



// WEBPACK FOOTER //
// ./src/components/analytics/SecurityOverview.js